import React, { useState } from 'react';
import axios from 'axios';
import './style.css';

const initialState = {
  tcno: '',
  name: '',
  surname: '',
  birthyear: '',
  month: '',
  day: ''
};

const Form = () => {
  const [formData, setFormData] = useState(initialState);
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  const handleChange = e => {
    let { name, value } = e.target;

    if (['tcno', 'birthyear', 'month', 'day'].includes(name)) {
      value = value.replace(/[^0-9]/g, '');
    }

    if (['name', 'surname'].includes(name)) {
      let filteredValue = value.replace(/[^a-zA-ZçÇğĞıİöÖşŞüÜ\s]/g, '');
      filteredValue = filteredValue.replace(/^\s+/, '');
      filteredValue = filteredValue.replace(/\s\s+/g, ' ');
      value = filteredValue;
    }

    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  // GÜNCELLENDİ: handlePaste fonksiyonu artık tek satır ve farklı tarih formatlarını destekliyor
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text/plain');

    // 1. ADIM: Gelen metni (çok satırlı bile olsa) tek bir satıra indirge ve fazla boşlukları temizle
    let remainingText = pastedText.replace(/\n/g, ' ').replace(/\s\s+/g, ' ').trim();

    let newData = {};

    // 2. ADIM: TC Kimlik No'yu bul ve metinden çıkar (11 haneli sayı bloğu)
    const tcMatch = remainingText.match(/\b(\d{11})\b/);
    if (tcMatch) {
      newData.tcno = tcMatch[1];
      remainingText = remainingText.replace(tcMatch[0], '');
    }

    // 3. ADIM: Tarihi bul ve metinden çıkar (farklı ayraçları destekler: boşluk, /, ., -)
    const dateMatch = remainingText.match(/\b(\d{1,2})\s?[./-]?\s?(\d{1,2})\s?[./-]?\s?(\d{4})\b/);
    if (dateMatch) {
      // Eşleşen tüm bloğu metinden çıkarmak için dateMatch[0] kullanılır
      remainingText = remainingText.replace(dateMatch[0], '');
      // Verileri kaydet
      newData.day = dateMatch[1].padStart(2, '0');
      newData.month = dateMatch[2].padStart(2, '0');
      newData.birthyear = dateMatch[3];
    }

    // 4. ADIM: Geriye kalan metni Ad ve Soyad olarak işle
    const finalNameText = remainingText.trim();
    if (finalNameText) {
      const nameParts = finalNameText.split(' ').filter(part => part);
      if (nameParts.length > 1) {
        newData.surname = nameParts.pop();
        newData.name = nameParts.join(' ');
      } else {
        newData.name = finalNameText;
      }
    }

    // 5. ADIM: Bulunan verileri mevcut form durumuyla birleştirerek güncelle
    setFormData(currentData => ({ ...currentData, ...newData }));
  };


  const handleClear = () => {
    setFormData(initialState);
    setNotification(null);
    setUserInfo(null);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setNotification(null);
    setUserInfo(null);

    if (formData.name.length !== formData.name.trim().length || formData.surname.length !== formData.surname.trim().length) {
      setNotification({ message: 'İsim veya Soyisim alanının başında veya sonunda boşluk olamaz.', type: 'error' });
      return;
    }

    const trimmedData = Object.fromEntries(
      Object.entries(formData).map(([key, value]) => [key, value.trim()])
    );

    if (Object.values(trimmedData).some(value => value === '')) {
      setNotification({ message: 'Lütfen tüm alanları doldurunuz.', type: 'error' });
      return;
    }

    const numericFields = {
      tcno: 'TC Kimlik No',
      birthyear: 'Doğum Yılı',
      month: 'Doğum Ayı',
      day: 'Doğum Günü'
    };

    for (const [field, name] of Object.entries(numericFields)) {
      if (!/^[0-9]+$/.test(trimmedData[field])) {
        setNotification({ message: `${name} sadece rakamlardan oluşmalıdır.`, type: 'error' });
        return;
      }
    }

    if (trimmedData.tcno.length !== 11) {
      setNotification({ message: 'TC Kimlik No 11 haneli olmalıdır.', type: 'error' });
      return;
    }

    setLoading(true);
    try {
      // GÜNCELLENDİ: 3. parametre olarak timeout ayarı eklendi
      const response = await axios.post(
        'https://api.antikbet.dev:2100/verifyUser/',
        trimmedData,
        {
          timeout: 300000 // 300,000 milisaniye = 5 dakika
        }
      );

      if (response.data.Result.Sonuc) {
        const userData = `
            <p>TC:<b> ${trimmedData.tcno}</b></p>
            <p>Ad:<b>  ${trimmedData.name}</b></p>
            <p>Soyad:<b>  ${trimmedData.surname}</b></p>
            <p>Doğum Günü:<b>  ${trimmedData.day}</b></p>
            <p>Doğum Ayı:<b>  ${trimmedData.month}</b></p>
            <p>Doğum Yılı:<b>  ${trimmedData.birthyear}</b></p>
          `;
        setUserInfo(userData);
        setNotification({ message: response.data.Result.Mesaj, type: 'success' });
      } else {
        setNotification({ message: response.data.Result.Mesaj, type: 'error' });
      }
    } catch (error) {
      console.error('Form gönderilirken bir hata oluştu:', error);

      // Bonus İyileştirme: Hatanın bir timeout hatası olup olmadığını kontrol et
      if (error.code === 'ECONNABORTED') {
        setNotification({ message: 'İstek zaman aşımına uğradı. Sunucu beklenenden yavaş yanıt verdi.', type: 'error' });
      } else {
        setNotification({ message: 'Sunucuya bağlanırken bir hata oluştu.', type: 'error' });
      }

    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="form-container">
      <h1 className="form-title">Kimlik Doğrulama</h1>
      <input type="text" name="tcno" placeholder="TC Kimlik No" value={formData.tcno} onChange={handleChange} maxLength="11" />
      <input type="text" name="name" placeholder="Ad" value={formData.name} onChange={handleChange} onPaste={handlePaste} />
      <input type="text" name="surname" placeholder="Soyad" value={formData.surname} onChange={handleChange} onPaste={handlePaste} />
      <input type="text" name="day" placeholder="Doğum Günü" value={formData.day} onChange={handleChange} maxLength="2" />
      <input type="text" name="month" placeholder="Doğum Ayı" value={formData.month} onChange={handleChange} maxLength="2" />
      <input type="text" name="birthyear" placeholder="Doğum Yılı" value={formData.birthyear} onChange={handleChange} maxLength="4" />

      <div className="button-group">
        <button type="submit" disabled={loading}>{loading ? 'Doğrulanıyor...' : 'Doğrula'}</button>
        <button type="button" onClick={handleClear} className="clear-button">Temizle</button>
      </div>

      {notification && (
        <div className={`notification ${notification.type}`}>
          <div className="icon">
            {notification.type === 'success' ? '✓' : '!'}
          </div>
          <p>{notification.message}</p>
        </div>
      )}

      {userInfo && (
        <div className="user-info" dangerouslySetInnerHTML={{ __html: userInfo }}></div>
      )}
    </form>
  );
};

export default Form;